/**
 * Read-only publish / unpublish run history.
 */
import { buildCollection } from "@firecms/core";
import { PublishLogItemsPreview } from "../components/PublishLogItemsPreview";
import { DESTINATION_LEVELS } from "../lib/destinationLevels";

const LOG_ITEM_PROPERTIES = {
  collection: { name: "Collection", dataType: "string" as const },
  id: { name: "Id", dataType: "string" as const },
  name: { name: "Name", dataType: "string" as const },
  level: {
    name: "Level",
    dataType: "string" as const,
    enumValues: DESTINATION_LEVELS,
  },
};

export const publishLogsCollection = buildCollection({
  id: "publish_logs",
  name: "Publish Logs",
  singularName: "Publish Log",
  path: "publish_logs",
  icon: "History",
  group: "Content",
  permissions: () => ({
    read: true,
    create: false,
    edit: false,
    delete: false,
  }),
  properties: {
    started_at: {
      name: "Started",
      dataType: "date",
    },
    completed_at: {
      name: "Completed",
      dataType: "date",
    },
    status: {
      name: "Status",
      dataType: "string",
      enumValues: [
        { id: "completed", label: "Completed", color: "greenDark" },
        { id: "failed", label: "Failed", color: "redDark" },
      ],
    },
    triggered_by: {
      name: "Triggered by",
      dataType: "string",
    },
    published_count: {
      name: "Published count",
      dataType: "number",
    },
    unpublished_count: {
      name: "Unpublished count",
      dataType: "number",
    },
    published: {
      name: "Published items",
      dataType: "array",
      Preview: PublishLogItemsPreview,
      of: {
        dataType: "map",
        properties: LOG_ITEM_PROPERTIES,
      },
    },
    unpublished: {
      name: "Unpublished items",
      dataType: "array",
      Preview: PublishLogItemsPreview,
      of: {
        dataType: "map",
        properties: LOG_ITEM_PROPERTIES,
      },
    },
    deploy_ref: {
      name: "Deploy branch",
      dataType: "string",
    },
    error: {
      name: "Error",
      dataType: "string",
      multiline: true,
    },
  },
});
